import PropTypes from 'prop-types';
import { variants, th } from 'style/theme';
import styled, { css } from 'styled-components';

const A = styled.a.attrs((props) => ({
  target: '_blank',
  rel: props.noOpener ? 'noopener noreferrer' : undefined
}))`
  cursor: pointer;

  ${variants('variant', {
    primary: css`
      color: ${th('colors.primaryLink.default')};

      :hover {
        color: ${th('colors.primaryLink.hover')};
      }
    `,
    secondary: css`
      color: ${th('colors.secondaryLink.default')};

      :hover {
        color: ${th('colors.secondaryLink.hover')};
      }
    `,
    tertiary: css`
      color: ${th('colors.tertiaryLink.default')};
      text-decoration: none;
    `,
    dark: css`
      color: ${th('colors.darkLink.default')};

      :hover {
        color: ${th('colors.darkLink.hover')};
      }
    `,
    light: css`
      color: ${th('colors.lightLink.default')};

      :hover {
        color: ${th('colors.lightLink.hover')};
      }
    `
  })}
`;

A.propTypes = {
  href: PropTypes.string.isRequired,
  variant: PropTypes.string,
  noOpener: PropTypes.bool
};

A.defaultProps = {
  variant: 'primary',
  noOpener: true
};

export default A;
